import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi, fmtTime } from "../lib/api";
import { PageHeader, Empty, OrderStatus } from "../components/common";
import { useMe } from "../components/AppShell";

export default function PrintConsole() {
  const api = useApi();
  const { me } = useMe();
  const [queue, setQueue] = useState(null);
  useEffect(() => { api.get("/print/queue").then((r) => setQueue(r.data)).catch(() => setQueue([])); }, [api]);
  if (!["admin", "print_team"].includes(me.role)) return <Empty testid="print-not-allowed">The print console is for the bsafe print team.</Empty>;
  return (
    <div data-testid="print-console">
      <PageHeader overline="Internal · print team" title="Production queue" />
      {queue && queue.length === 0 && <Empty testid="print-queue-empty">No paid orders waiting.</Empty>}
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">{(queue || []).map((o) => (
        <Link key={o.id} to={`/app/print/${o.id}`} className="panel p-5 lift block" data-testid={`queue-order-${o.invoice_no}`}>
          <div className="flex justify-between items-start"><span className="font-mono font-semibold">{o.invoice_no}</span><OrderStatus value={o.status} /></div>
          <div className="font-display font-bold mt-3">{o.group_name}</div>
          <div className="text-xs text-slate-400 mt-1">Paid {fmtTime(o.paid_at)}</div>
          <div className="mt-4 h-1.5 rounded bg-slate-700 overflow-hidden"><div className="h-full bg-emerald-500" style={{ width: `${o.tags_total ? (o.tags_written * 100) / o.tags_total : 0}%` }} /></div>
          <div className="text-xs text-slate-300 mt-1">{o.tags_written}/{o.tags_total} tags written & verified</div>
        </Link>))}</div>
    </div>
  );
}
